import React from 'react';
import { connect } from 'react-redux';
import EditBankForm from '../../../../Components/Forms/Admin/Banks/EditBank';
import ModalsWrappedForm from '../../../../Components/Forms/ModalsWrappedForm';
import trans from '../../../../Translations/translation.service';
import { actions as banksActions, types } from '../../../../Redux/Api/Banks';
import { PRIVATE_PATHS } from '../../../config';
import { MALE_CODE } from '../../../../Constants';
import { EDIT_ACTIONS } from '../../../../Components/Forms/Admin/Banks/config';
import { catchApiItemErrors } from '../../../../Helpers';

class EditBank extends React.Component {
  getBank = () => {
    const { id } = this.props.match.params;

    this.props.getBank(id);
  };

  loading = () => {
    const { isFetchingBank, isUpdatingBank } = this.props;
    return isFetchingBank || isUpdatingBank;
  };

  updateBank = data => {
    return this.props.updateBank(data).catch(
      catchApiItemErrors,
    );
  };

  componentDidMount() {
    this.getBank();
  }

  render() {
    const { bank, history, success } = this.props;
    const loading = this.loading();
    const subject = trans('resources.singular.bank');

    return (
      <ModalsWrappedForm
        gender={MALE_CODE}
        history={history}
        loading={loading}
        open={success}
        path={PRIVATE_PATHS.adminBanks.path}
        subject={subject}
        successMessage="successOpSingM"
        type="edit"
      >
        {
          bank &&
          <EditBankForm
            actions={EDIT_ACTIONS}
            history={history}
            onSubmit={this.updateBank}
            path={PRIVATE_PATHS.adminBanks.path}
          />
        }
      </ModalsWrappedForm>
    );
  }
}

const mapStateToProps = ({
  banks: { isFetchingItem, isUpdating, item },
  reduxRestResponse: { body, success, type },
}) => ({
  body,
  bank: item,
  isFetchingBank: isFetchingItem,
  isUpdatingBank: isUpdating,
  success: type === types.UPDATE_BANK && success,
});

export default connect(
  mapStateToProps,
  {
    ...banksActions,
  }
)(EditBank);
